  <section id="Dashboard">
    <div class="container-fluid" style="margin-bottom:8px">
      <div class="container">
        <div [hidden]="hideCloseToNewInvestorAnnouncementBanner">
          <div *ngIf="profileDashboardModel?.isClosedToNewInvestors || profileDashboardModel?.isClosed" class="alert col-md-12">
              <div>
              <h5 class="rps-heading-five col-11"
                *ngIf="profileDashboardModel?.isClosedToNewInvestors && !profileDashboardModel?.isClosed"
                [innerHTML]="closedToNew?.contentValue"></h5>
              <h5 class="rps-heading-five col-11" *ngIf="profileDashboardModel?.isClosed"
                [innerHTML]="closedToAll?.contentValue"></h5>
              <span class="closebtn" role="button" aria-label="Close banner" tabindex="0"
                (click)="closeToNewInvestorAnnouncementBanner()">&times;</span>
            </div>
          </div>
        </div>
        <div *ngIf="profileDashboardModel?.isInternalFund" [hidden]="hideAnnouncementBanner" class="alert col-md-12">
          <div class="col-11" [innerHTML]="announcementBanner"></div>
          <span class="closebtn announcementBannerCloseBtn" role="button" aria-label="Close banner" tabindex="0"
            (click)="closeAnnouncementBanner()">&times;</span>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <div class="container">
        <div *ngIf="displayExpenseRatioBanner" [hidden]="hideExpenseRatioBanner" class="alert col-md-12">
          <div class="col-11" [innerHTML]="expenseRatioBanner"></div>
          <span class="closebtn announcementBannerCloseBtn" role="button" aria-label="Close banner" tabindex="0"
            (click)="closeExpenseRatioBanner()">&times;</span>
        </div>
      </div>
    </div>
    <div
      *ngIf="(profileDashboardModel?.isExternalFund && !hideNotAvailableAndTransferOnlyBanner) && (fundNonTransferableToVGIMsg || nonFundAccessMsg)"
      class="container-fluid">
      <div class="container mt-2">
        <div class="alert col-md-12" *ngIf="!(profileDashboardModel?.isExternalFund && profileDashboardModel?.isETF)">
          <h5 class="transferbanner col-11" *ngIf="fundNonTransferableToVGIMsg && !nonFundAccessMsg"
              [innerHTML]="nonVgFundNotAvailable?.contentValue"></h5>
          <h5 class="rps-heading-five col-11" *ngIf="!fundNonTransferableToVGIMsg && nonFundAccessMsg"
              [innerHTML]="nonVgFundTransferOnly?.contentValue"></h5>
          <span class="closebtn" role="button" aria-label="Close banner" tabindex="0"
                (click)="closeNotAvailableAndTransferOnlyBanner()">&times;</span>
        </div>
      </div>
    </div>


    <div *ngIf="profileDashboardModel?.isExternalFund" class="container-fluid">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-8">
          <p *ngIf="profileDashboardModel?.isExternalFund" class="partnerFund mb-1">NON-VANGUARD FUNDS</p>
          <h1 class="ticker rps-display-one" data-rpa-tag-id="dashboard-symbol">{{profileDashboardModel?.ticker ? profileDashboardModel.ticker :
            (profileDashboardModel?.is529 ? '529 Portfolio': '&mdash;')}}
            <span class="fund-name rps-heading-one" data-rpa-tag-id="longName">{{profileDashboardModel?.fundName ?
              profileDashboardModel.fundName : '&mdash;'}}</span>
          </h1>
          <p class="db-title rps-paragraph-two"
            *ngIf="profileDashboardModel?.isExternalFund && profileDashboardModel?.isNTFFund && !profileDashboardModel.isLoadFund">
            <a role="button" tabindex="0" (click)="setDialogInfo('No-transaction-fee (NTF) funds');dashboardComponentModal.openModalDialog($event);"
               href="javascript:void(0)" class="marketPriceLink dialog-button">NTF
              funds</a>
          </p>
          <p class="db-title rps-paragraph-two" *ngIf="profileDashboardModel?.isExternalFund && profileDashboardModel?.isLoadFund">
            <a role="button" tabindex="0" (click)="setDialogInfo('Load Funds');dashboardComponentModal.openModalDialog($event);"
               href="javascript:void(0)" class="marketPriceLink dialog-button">Load funds</a>
          </p>
          <p class="db-title rps-paragraph-two"
            *ngIf="profileDashboardModel?.isExternalFund && profileDashboardModel?.hasTransactionFee && !profileDashboardModel.isLoadFund">
            <a role="button" tabindex="0" (click)="setDialogInfo('TransactionFee Funds'); dashboardComponentModal.openModalDialog($event);"
               href="javascript:void(0)" class="marketPriceLink dialog-button">TF funds</a>
          </p>

          <p class="also-available rps-paragraph-one" [innerHTML]="subtitle"
            *ngIf="subtitle && profileDashboardModel?.isInternalFund"></p>
          <div class="row btn-area" [ngClass]="{'mb-0': !isFormattedForActionButtons()}">
            <buy-button
              *ngIf="isBuyAvailable()"
              class="btn buy" [fundInput]='profileDashboardModel' size="'medium'"></buy-button>
            <add-to-wl *ngIf="shouldShowWatchlistButton()" id="watchlistMFEButton" class="btn watchlist" variant="secondary" [fundData]='wlFundData' ariaLabelText="Add to Watchlist"></add-to-wl>
            <compare-button
              *ngIf="isCompareAvailable()"
              class="btn compare" [fundInput]='profileDashboardModel' size="'medium'">
            </compare-button>

          </div>
        </div>
        <div class="col-md-6 col-lg-4 ml-xs-4">
          <dashboard-stats [dashboardModel]='dashboardModel' [profileDashboardModel]="profileDashboardModel" [expenseRatioFootnote]='dashboardModel?.expenseRatioFootnote'
            [yieldNote]="dashboardModel?.yieldNote"></dashboard-stats>
        </div>
      </div>
    </div>

    <c11n-modal-dialog modalId="dashboardComponentModal" [headingText]="dialogTitle" #dashboardComponentModal>
      <div c11n-modal-dialog-body>
        <ng-container *ngTemplateOutlet="simpleDialogContent"></ng-container>
      </div>
    </c11n-modal-dialog>
  </section>
  <ng-template #simpleDialogContent>
    <div class="load-body-content">
      <p class="rps-paragraph-one" id="DashboardFundPopupDialogDesc" [innerHTML]="noteText"></p>
    </div>
  </ng-template>
